import { getStore, setStore } from '@/util/store'
import { staff, certification } from '@/api/staff/index';
import { getList as getRoleList, getRoleTree, getBaseRoleTree } from '@/api/system/role';
import {
  getList as getComponyList, getDeptListTree as getDeptTree, getBusinessSection, deptTree, getList as getDeptList,
} from '@/api/system/dept';
import { getList as getChildList, getDictTree } from '@/api/system/dict';
import { getList as getPostList, getTradeList } from '@/api/system/post';
import { getDictTree as getDicbiztTree } from '@/api/system/dictbiz';
import { getTopMenu, getRoutes, getMenuTree } from '@/api/system/menu';
import { getList as getUserList } from '@/api/system/user';
import jobAPI from '@/api/staff/job/index';
import vacationAPI from '@/api/staff/vacation/option';
import interviewAPI from '@/api/staff/interview/index';
import projectAPI from '@/api/base/project'
import addressAPI from '@/api/base/address';
import countryAPI from '@/api/base/country'
import universityAPI from '@/api/base/university'
import cityAPI from '@/api/base/city'
import WORKER from '@/api/worker/index'
import holidayAPI from '@/api/holiday/index'
import positiveRecordAPI from '@/api/staff/positiveRecord/index';
// 获取unit人员数据
import { getRoomWorkerList, getList as unitList } from '@/api/worker/dormitory/room'
import { getBlockWorkerList, getDwellplotList, getBlockList } from '@/api/worker/dormitory/block'

// 获取工长数据
import { getSupervisor } from '@/api/worker/teams'
import { deepClone } from '@/util/util';

import ApplyAPi, { getAllProcess } from '@/api/apply/index'

/**
 * 格式化数据
 * @param {Array} array 数据
 * @param {String} label 名称key
 * @param {String} label 值key
 * @returns {Array} 格式化之后的值
 */
export const formatArray = (array, label, value) => {
  const formatRes = []
  for (let i = 0; i < array.length; i += 1) {
    const item = array[i];
    if (!item.isPositiveDisabled) {
      const toStringLabel = item[label] ? item[label].toString() : ''
      const toStringValue = item[value] ? item[value].toString() : ''
      formatRes.push(
        {
          label: toStringLabel,
          value: toStringValue,
        },
      )
    } else {
      formatRes.push(
        {
          label: item.staffName,
          value: item.staffName,
          disabled: true
        },
      )
    }

  }

  return formatRes
}
export const setPositiveByName = (array) => {
  let typeObj = {}
  let newArr = []
  array.forEach(item => {
    if (item.typeName && item.typeName in typeObj) {
      typeObj[item.typeName].push(item)
    } else {
      typeObj[item.typeName] = []
      typeObj[item.typeName].push(item)
    }
  })
  for (let key in typeObj) {
    if (typeObj.hasOwnProperty(key)) { // 只遍历对象自身的属性
      newArr.push({ staffName: key, isPositiveDisabled: true })
      newArr.push(...typeObj[key])
    }
  }

  return newArr

}

/**
 * 格式化树形数据
 * @param {Array} array 数据
 * @param {String} label 名称key
 * @param {String} label 值key
 * @returns {Array} 格式化之后的值
 */
export const dfs = (array, label = 'title', value = 'id') => {
  function walkAndCopy(tree, depth = 1) {
    const copy = {}
    copy.label = tree[label]
    copy.value = tree[value]
    if (tree.children) {
      copy.children = []
      tree.children.forEach(node => {
        const subTree = walkAndCopy(node, depth + 1)
        if (subTree) {
          copy.children.push(subTree)
        }
      })
    }
    return copy
  }
  const res = []
  if (Array.isArray(array)) {
    array.forEach(node => {
      const subTree = walkAndCopy(node, 1)
      if (subTree) {
        res.push(subTree)
      }
    })
  }
  return res
}

/**
 * 数组扁平化
 * @param {Array} array 数组
 * @param {String} label 显示名称的key
 * @param {String} value 值的key
 * @param {String} children 子集的key
 * @returns {Array} 扁平化之后的数组
 */
export const flattenArray = (array, label = 'label', value = 'value', children = 'children') => array.reduce((result, item) => result.concat(
  Array.isArray(item[children]) ? flattenArray([{ label: item[label], value: item[value] }, ...item[children]], label, value, children) : item,
), [])

/**
 *自定义数据源
 */
export class getCustomDicts {
  static async staff(params, option) {
    const res = await staff.list(1, -1, params)
    const temp = res.data.data.records
    return formatArray(temp, 'enName', option.saveKey ? option.saveKey : 'id')
  }

  static async authStaff() {
    const res = await staff.authStaffList()
    const temp = res.data.data
    return temp
  }

  static async worker(params, option) {
    // const res = await staffAPI.list(1, -1, params)
    // const temp = res.data.records
    const temp = []
    return formatArray(temp, 'name', option.saveKey ? option.saveKey : 'id')
  }

  static async site(params, option) {
    // const res = await staffAPI.list(1, -1, params)
    // const temp = res.data.records
    const temp = []
    return formatArray(temp, 'name', option.saveKey ? option.saveKey : 'id')
  }

  static async positiveStaff(params, option) {

    const res = await positiveRecordAPI.getList(1, -1, params)
    const temp = res.data.data.records
    return formatArray(temp, 'staffName', option.saveKey ? option.saveKey : 'staffId')
  }

  static async positiveNewStaffAdd(params, option) {

    const res = await ApplyAPi.pageConfirmationAssessment(1, -1, params)
    let temp = res.data.data.records
    temp = setPositiveByName(temp)
    temp.forEach(item => {
      // eslint-disable-next-line no-param-reassign
      if (!item.isPositiveDisabled) {
        item.staffName = `${item.name} - ${item.typeName}`
      }


    })
    console.log(option.saveKey)

    return formatArray(temp, 'staffName', option.saveKey ? option.saveKey : 'staffId')
  }


  static async user(params) {
    const res = await getUserList(1, -1, params)
    const temp = res.data.data.records
    return formatArray(temp, 'realName', 'id')
  }

  static async role() {
    const res = await getRoleTree('000000')
    const temp = res.data.data
    return dfs(temp)
  }

  static async baseRole() {
    const res = await getBaseRoleTree('000000')
    const temp = res.data.data
    return dfs(temp)
  }

  static async dict() {
    const res = await getDictTree('000000')
    const temp = res.data.data
    return dfs(temp)
  }

  static async dictbiz() {
    const res = await getDicbiztTree('000000')
    const temp = res.data.data
    return dfs(temp)
  }

  static async dept(params = { deptCategory: '2' }) {
    const deptCategory = params.deptCategory || '2'
    const parentId = (params.deptCategory !== 3 && !params.parentId) ? '1123598813738675201' : params.parentId;
    const res = await getDeptTree(deptCategory, parentId)
    const temp = res.data.data
    return dfs(temp, 'deptName', 'id')
  }

  static async team(p = {}) {
    const params = p
    const parentId = !params.parentId ? '1123598813738675201' : params.parentId;
    const deptCategory = params.deptCategory || '2'
    params.deptType = 3
    params.deptCategory = deptCategory
    params.parentId = parentId
    const res = await deptTree(params)
    const temp = res.data.data
    return dfs(temp, 'deptName', 'id')
  }

  static async deptBusinessSection(p) {
    const res = await getDeptList(1, -1, p)
    const temp = res.data.data
    return dfs(temp, 'deptName', 'id')
  }

  static async organization() {
    const res = await getDeptTree()
    const temp = res.data.data
    return dfs(temp)
  }

  static async post(params) {
    const res = await getPostList(1, -1, params)
    const temp = res.data.data.records
    return formatArray(temp, 'postName', 'id')
  }

  // 工人position
  static async position(params) {
    const res = await getPostList(1, -1, { ...params, ...{ category: 4 } })
    const temp = res.data.data.records
    return formatArray(temp, 'postName', 'id')
  }

  static async company() {
    const res = await getComponyList(1, -1, { deptCategory: '1' })
    const temp = res.data.data
    return formatArray(temp, 'deptName', 'id')
  }
  static async uenCompany() {
    const res = await getComponyList(1, -1, { deptCategory: '1' })
    const temp = res.data.data
    return formatArray(temp, 'uen', 'id')
  }

  static async project(params) {
    const res = await projectAPI.getList(1, -1, params)
    const temp = res.data.data.records.concat({
      projectName: 'N/A',
      id: '0',
    })
    const result = temp.map(el => ({
      projectName: el.projectName,
      id: el.id,
    }))
    return formatArray(result, 'projectName', 'id')
  }

  static async attendancePosition(params) {
    const res = await addressAPI.getList(1, -1, params)
    const temp = res.data.data.records
    return formatArray(temp, 'addressName', 'id')
  }

  static async developerproject(params) {
    const res = await projectAPI.getDeveloperprojectList(1, -1, params)
    const temp = res.data.data.records
    return formatArray(temp, 'projectname', 'projectid')
  }

  static async special() {
    const res = await WORKER.getSpeciaList(1, -1)
    const temp = res.data.data.records
    return formatArray(temp, 'specialistName', 'specialistId')
  }

  // 根据project获取team
  static async teams(params) {
    const res = await WORKER.getTeamList(params)
    const temp = res.data.data
    // const result = temp.map(el => {
    //   if (el.id === '0') {
    //     return {
    //       teamName: el.teamName,
    //       id: el.id,
    //     }
    //   }
    //   return {
    //     teamName: `${el.teamName}'s TEAM`,
    //     id: el.id,
    //   }
    // })
    return formatArray(temp, 'teamName', 'id')
  }

  // team组件使用
  static async workerteam(params) {
    const res = await WORKER.getTeamList(params)
    const temp = res.data.data
    return formatArray(temp, 'teamName', 'id')
  }

  // 获取工长列表
  static async supervisor(params) {
    const res = await getSupervisor(params)
    const temp = res.data.data
    return formatArray(temp, 'name', 'id')
  }

  // 获取specialist下的工种
  static async trade(params) {
    const res = await getTradeList(1, -1, params)
    const temp = res.data.data.records
    return formatArray(temp, 'postName', 'id')
  }

  static async menuTop() {
    const res = await getTopMenu('000000')
    const temp = res.data.data
    return dfs(temp)
  }

  static async menuTree() {
    const res = await getMenuTree(0)
    const temp = res.data.data
    return dfs(temp)
  }

  static async menuRoute() {
    const res = await getRoutes('000000')
    const temp = res.data.data
    return dfs(temp)
  }

  static async interview(params) {
    const res = await interviewAPI.getList(1, -1, params)
    const temp = res.data.data.records
    return formatArray(temp, 'name', 'id')
  }

  static async vacationInfo(params) {
    const userAllInfo = getStore({ name: 'userAllInfo' })
    let res = {}
    if (userAllInfo.staffInfo.status === 0) {
      // leaveType: 1
      res = await vacationAPI.getList(1, -1, { ...params, userType: 1, leaveType: 1 })
    } else {
      res = await vacationAPI.getList(1, -1, { ...params, userType: 1 })
    }
    // const res = await vacationAPI.getList(1, -1, { ...params, userType: 1 })
    const temp = res.data.data.records
    return formatArray(temp, 'vacationName', 'id')
  }

  static async workerVacationInfo(params) {
    const res = await vacationAPI.getList(1, -1, { ...params, userType: 2 })
    const temp = res.data.data.records
    return formatArray(temp, 'vacationName', 'id')
  }

  // 获取假期方案
  static async schemeList(params) {
    const res = await holidayAPI.getSchemeList(1, -1, params)
    const temp = res.data.data.records
    return formatArray(temp, 'schemeTitle', 'id')
  }

  // 获取工人假期方案
  static async workerSchemeList(params) {
    const res = await holidayAPI.getWorkerHolidayList(1, -1, params)
    const temp = res.data.data.records
    // return formatArray(temp, 'holidayName', 'id')
    return formatArray(temp, 'schemeTitle', 'id')
  }

  static async job(params) {
    const res = await jobAPI.getList(1, -1, params)
    const temp = res.data.data.records
    return formatArray(temp, 'jobName', 'id')
  }

  static async nationality(params) {
    const isEn = getStore({ name: 'language' }) === 'en'
    const res = await countryAPI.getList(1, -1, params)
    const temp = res.data.data.records
    return formatArray(temp, (isEn ? 'countryBritannica' : 'chineseName'), 'code')
  }

  static async university(params = {}) {
    if (!params.code) { return [] }
    const res = await universityAPI.getList(1, -1, params)
    const temp = res.data.data.records
    return formatArray(temp, 'name', 'recid')
  }

  static async city(params = {}) {
    if (!params.code) { return [] }
    const res = await cityAPI.getList(1, -1, params)
    const temp = res.data.data.records
    return formatArray(temp, 'name', 'id')
  }

  static async cert(params) {
    const res = await certification.getList(1, -1, params)
    const temp = res.data.data.records
    return formatArray(temp, 'certName', 'id')
  }

  static async businessSection(params) {
    const res = await getBusinessSection()
    const temp = res.data.data
    return formatArray(temp, 'title', 'id')
  }

  static async unit(params) {
    const res = await getRoomWorkerList(1, -1, params)
    const temp = res.data.data.records
    return formatArray(temp, 'name2', 'workerId')
  }

  static async block(params) {
    const res = await getBlockWorkerList(1, -1, params)
    const temp = res.data.data.records
    return formatArray(temp, 'name2', 'workerId')
  }

  // 获取宿舍的dict
  static async dormitory(params) {
    const res = await getDwellplotList(1, -1, params)
    const temp = res.data.data.records
    return formatArray(temp, 'dormitoryName', 'id')
  }

  // 获取楼栋dict
  static async BLk(params) {
    const res = await getBlockList(1, -1, params)
    const temp = res.data.data.records
    return formatArray(temp, 'blkCode', 'id')
  }

  // 获取房间dict
  static async UnitRoom(params) {
    const res = await unitList(1, -1, params)
    const temp = res.data.data.records
    return formatArray(temp, 'unitNo', 'id')
  }

  // 获取所有员工流程
  static async staffTemplateForm(params) {
    const res = await getAllProcess(1, -1, params)
    const temp = res.data.data.records
    const filter = []
    temp.forEach(o => {
      if (o.configuration) {
        const t = JSON.parse(o.configuration)
        if (t.type === 1) {
          filter.push(o)
        }
      }
    })
    return formatArray(filter, 'formName', 'id')
  }

  static async jobTitle(params) {
    const res = await WORKER.getPosition(1, -1, params)
    const temp = res.data.data.records
    return formatArray(temp, 'name', 'name')
  }
}

/**
 * 获取store字典数据
 * @param {String} code 值
 * @param {String} type 类型：dict/dictBiz
 * @returns {Array} 字典
 */
export const getDictionary = (code, type = 'dict') => {
  const dictArr = getStore({ name: 'dicts' })[type]
  const findDict = dictArr.find(o => o.code === code)
  return findDict ? findDict.children : []
}

/**
 * 将字典数据存入缓存
 * @param {String} code 值
 * @param {String} type 类型：dict/dictBiz
 * @returns {Array} 字典
 */
export const setBufferDictionary = (code, type = 'dict', params, data) => {
  console.log(code, 'codedddddddd')
  const obj = getStore({ name: 'dictsStaticData' }) || {}
  const objType = obj[type] || {}

  const objDict = objType[code] || {}

  let paramsT = 'default'
  if (typeof params === 'object') {
    paramsT = JSON.stringify(params)
  }
  objDict[paramsT] = data

  objType[code] = objDict
  obj[type] = objType

  // console.log(obj, '_________bufferDictionary________', code, paramsT);
  setStore(
    {
      name: 'dictsStaticData',
      content: obj,
    },
  )
}

/**
 * 试图从缓存内取字典数据
 * @param {String} code 值
 * @param {String} type 类型：dict/dictBiz
 * @returns {Array} 字典
 */
export const getBufferDictionary = (code, type = 'dict', params) => {
  const obj = getStore({ name: 'dictsStaticData' }) || {}
  const objType = obj[type] || {}

  const objDict = objType[code] || {}

  let paramsT = 'default'
  if (typeof params === 'object') {
    paramsT = JSON.stringify(params)
  }
  // console.log(objDict, 'getBufferDictionary', code, paramsT);
  return objDict[paramsT]
}

/**
 * 获取默认数据库字典表数据
 * @param {String} code 值
 * @param {Boolean} isDictBiz 是否是dictBiz表
 * @returns {Array} 字典
 */
export const getDefaultDicts = async (code, isDictBiz = false) => {
  let temp = []
  if (code === 'dictBiz' || code === 'dict') {
    temp = getStore({ name: 'dicts' })[code]
    const res = await formatArray(temp, 'dictValue', 'code')
    return res
  }
  const type = isDictBiz ? 'dictBiz' : 'dict'
  temp = getDictionary(code, type)
  const res = await formatArray(temp, 'dictValue', 'dictKey')
  return res
}

/**
 * 获取字典
 * @param {Object} option 配置
 * @returns {Array} 格式化后数据
 */
export const getDicts = async option => {
  const code = option.dictCode || option.dictBizCode
  // 不使用缓存数据的字典code集合
  const notBufferDictionary = ['attendancePosition', 'positiveStaff', 'positiveNewStaff']
  if (getCustomDicts[code]) {
    const type = option.dictBizCode ? 'dictBiz' : 'dict'
    const query = deepClone(option.dictQuery)
    let res = []
    const lang = getStore({ name: 'language' })
    const bufferDictionary = getBufferDictionary(`${code}-${lang}`, type, query)
    if (!bufferDictionary || notBufferDictionary.includes(code)) {
      res = await getCustomDicts[code](query, option)
      // positiveNewStaffAdd 需要那最新值

      if (code !== 'positiveNewStaffAdd') {
        setBufferDictionary(`${code}-${lang}`, type, option.dictQuery, res)
      }

    } else {
      res = bufferDictionary
    }
    return res
  }
  const res = await getDefaultDicts(code, !!option.dictBizCode)
  return res
}

export default true
